import { SortDirection } from '@angular/material/sort';

import { BaseListFilter } from '../../../models/base-list-filter.model';
import { Day } from '../../../models/day.type';
import { UserStatusEnum } from '../../users/models/user-status.enum';
import { DealStatusEnum, DealStautsCommonEnum } from './deal.status.enum';
import { DealAgeFilterEnum } from './deal-age-filter.enum';

export class DealsFilter extends BaseListFilter {
  userId?: number;
  userName?: string;
  createdAtFrom?: Date;
  createdAtTo?: Date;
  paymentDateFrom?: Date;
  paymentDateTo?: Date;
  closingDateFrom?: Day;
  closingDateTo?: Day;
  searchByUser?: string;
  fetchCurrentDebt = true;
  fetchPromisedPayments?: boolean;
  fetchTotalAmounts?: boolean;
  fetchDealBalances?: boolean;
  fetchUser?: boolean;
  fetchFacility?: boolean;
  age?: DealAgeFilterEnum;
  //
  closingDateFromAsDate?: Date;
  closingDateToAsDate?: Date;
  statusCommon?: DealStautsCommonEnum;
  fetchLoanFacilityEligible?: boolean;
  fetch90DaysEligibleOnly?: boolean;
  excludeStatus?: DealStatusEnum | DealStatusEnum[];

  constructor(
    public status: DealStatusEnum | DealStatusEnum[] | null = [
      DealStatusEnum.Requested,
    ],
    public sortBy: string = 'id',
    public sortDirection: SortDirection = 'desc',
    public userStatus?: UserStatusEnum[],
  ) {
    super();
  }
}
